import React, { useState } from "react";
import { Link } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

export default function Footer() {
  const [email, setEmail] = useState("");

  const handleSubscribe = () => {
    if (email) {
      toast.success("Thank you for subscribing!");
      // Additional logic for handling the subscription can go here
      setEmail("");
    } else {
      toast.error("Please enter a valid email address.");
    }
  };

  return (
    <>
      <Toaster />
      <footer className="bg-primary-450 py-12 md:px-28 px-4 font-sans tracking-wide mt-14">
        <div className="grid max-sm:grid-cols-1 lg:grid-cols-3 items-center gap-8">
          <h2 className="lg:col-span-2 text-xl font-semibold text-gray-300">
            गुणस्तरीय प्राविधिक शिक्षाका लागि (HVTC)
          </h2>
          <div className="bg-transparent border  border-primary-350 flex px-1 py-1 rounded-full">
            <input
              name="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full outline-none bg-transparent pl-4 text-sm text-gray-300"
            />
            <button
              type="button"
              onClick={handleSubscribe}
              className="bg-gray-600 hover:bg-gray-700 transition-all text-gray-200 text-sm rounded-full px-5 py-2.5"
            >
              Subscribe
            </button>
          </div>
        </div>

        <hr className="my-12 border-gray-600" />

        <div className="grid max-sm:grid-cols-1 max-lg:grid-cols-2 lg:grid-cols-5 lg:gap-10 max-lg:gap-8">
          <div className="lg:col-span-3 max-lg:col-span-full">
            <Link to="/" className="flex  gap-2">
              <span className=" text-gray-300 text-xl font-serif  ">
                HOLY VISION TECHNICAL CAMPUS
              </span>
            </Link>
            <p className="text-gray-300 text-sm lg:max-w-sm mt-6">
              Holy Vision Technical Campus , Thapagaun, New Baneshower Kathmandu
              Nepal .
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-gray-300">
              Quick Link
            </h4>
            <ul className="space-y-4">{renderLinks(services)}</ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-gray-300">
              Contact Us
            </h4>
            <ul className="space-y-4">{renderLinks(aboutUs)}</ul>
          </div>
        </div>

        <p className="text-sm text-gray-300 mt-8">
          Copyright © 2024
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.cloudsnepalweb.com/"
            className="hover:underline mx-1"
          >
            Clouds Nepal Web
          </a>
          All Rights Reserved.
        </p>
      </footer>
    </>
  );
}

const services = [
  { name: "About Us", path: "/about" },
  { name: "Apply Online", path: "/apply" },
  { name: "Direct Contact Us", path: "/contact" },
];

const aboutUs = [
  { name: "Call Us :- 01-5244745 , 014793874" },
  { name: "Email :-  hvtcampus@gmail.com" },
  { name: "Location :- Thapagaun, New Baneshower Kathmandu Nepal " },
];

const renderLinks = (links) =>
  links.map((link, index) => (
    <li key={index}>
      <Link
        to={link.path}
        className="text-gray-300 hover:text-gray-400 text-sm"
      >
        {link.name}
      </Link>
    </li>
  ));
